module.exports = __webpack_public_path__ + "static/media/conceptbiu-logo.2b6a4886.png";